import { Box, Typography } from "@mui/material";
import { useTranslationApp } from "../../lib/i18next";
import {
  SUGGESTION_BUDGET_CURRENT,
  SUGGESTION_BUDGET_MINIMUM,
  SUGGESTION_BUDGET_PREVIOUS,
  SUGGESTION_BUDGET_TEXT,
  VALUE_WITH_CURRENCY,
} from "../../i18n/keysTranslations";

const BudgetSuggestionsAlert = ({
  effectiveBudget,
  budgetMinimum,
  suggestedBudget,
  currency,
}) => {
  const { t } = useTranslationApp();

  return (
    <Box>
      <Typography variant="body2" fontSize="16px">
        {t(SUGGESTION_BUDGET_TEXT)}
      </Typography>
      <Box mt={2}>
        <Typography variant="body2" fontSize="16px">
          {t(SUGGESTION_BUDGET_PREVIOUS)}:{" "}
          <b>{t(VALUE_WITH_CURRENCY, { value: effectiveBudget, currency })}</b>
        </Typography>
        <Typography variant="body2" fontSize="16px">
          {t(SUGGESTION_BUDGET_MINIMUM)}:{" "}
          <b>{t(VALUE_WITH_CURRENCY, { value: budgetMinimum, currency })}</b>
        </Typography>

        {suggestedBudget > budgetMinimum && (
          <Typography variant="body2" fontSize="16px">
            {t(SUGGESTION_BUDGET_CURRENT)}:{" "}
            <b>{t(VALUE_WITH_CURRENCY, { value: suggestedBudget, currency })}</b>
          </Typography>
        )}
      </Box>
    </Box>
  );
};
export default BudgetSuggestionsAlert;
